var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.624 6L6.907 13.371h-.036c-.444 0-4.871.124-4.871 5.074c0 2.151.954 3.754.954 3.754l20.354 34.042c1.946 3.1 6.079 1.159 6.079 1.159l31.211-15.205l-1.168-1.185c-.275-1.423-.435-4.058 1.497-6.02c.043-.044.051-.104.074-.159L62 34.43zm.829 6.492l5.463 5.947l-20.391 7.467l-4.816-7.576zM22.586 51.138L4.682 21.19C4.674 21.179 4 19.981 4 18.445c0-1.948.954-2.689 1.887-2.948L26.36 47.433c-1.541.667-3.263 2.191-3.774 3.705m35.826-12.997c-.065.46-.098.908-.091 1.328l-20.489 9.725l20.562-8.726c.02.16.038.319.063.463L32.192 53.617l26.472-11.741l.016.063l-29.293 14.013c-.014.009-1.351.72-2.691.72c-1.324 0-2.149-.68-2.525-2.078c-.967-3.592 4.527-5.628 4.61-5.658l30.383-13.145c-.218.4-.369.808-.495 1.213l-19.287 9.079z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBook);
export default __webpack_public_path__ + "static/media/blue-book.df4e75578bbab190ab4fb75f779869f4.svg";
export { ForwardRef as ReactComponent };